import { render, staticRenderFns } from "./AppMain.vue?vue&type=template&id=12954c8d&"
import script from "./AppMain.vue?vue&type=script&lang=js&"
export * from "./AppMain.vue?vue&type=script&lang=js&"
import style0 from "./AppMain.vue?vue&type=style&index=0&id=12954c8d&prod&lang=less&"
import style1 from "./AppMain.vue?vue&type=style&index=1&id=12954c8d&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports